import { registerRoot } from "remotion";
import { Root } from "./root";

registerRoot(Root);
